export default "__VITE_ASSET__BGsfY1nm__"